<template>
  <section
    class="forHome features"
    v-waypoint="{
      active: true,
      callback: showHidePaginator,
      options: intersectionOptions,
    }"
  >
    <v-touch @swipeleft="moveTo(1)" @swiperight="moveTo(0)">
      <Grid
        class="features-grid forHome"
        v-bind:style="{ transform: 'translateX(' + column.translateX + 'px)' }"
      >
        <div class="feature-column">
          <div class="teaser">
            <div class="teaser-image">
              <img src="/static/img/hand-axe.svg" />
            </div>
            <router-link to="/act-like-a-designer" class="teaser-link">
              <strong>1</strong>
              <span>Act like a designer</span>
              <ArrowAsLink />
            </router-link>
            <ul class="teaser-preview">
              <li>Transformational design</li>
              <li>Strategic design</li>
              <li>Conceptional design</li>
              <li>Facilitation</li>
            </ul>
          </div>
        </div>
        <div class="feature-column">
          <div class="teaser">
            <div class="teaser-image">
              <img src="/static/img/smart-phone.svg" />
            </div>
            <router-link to="/getting-practical" class="teaser-link">
              <strong>2</strong>
              <span>Getting practical</span>
              <ArrowAsLink />
            </router-link>
            <ul class="teaser-preview">
              <li>Design management</li>
              <li>Service design</li>
              <li>Design operations</li>
              <li>Design engineering</li>
            </ul>
          </div>
        </div>
        <div class="giantArrow">
          <svg
            width="2442"
            height="127"
            viewBox="0 0 2442 127"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M2374.37 4.70923C2374.37 4.70923 2409.59 39.8669 2432.93 63.4367L2374.38 121.828"
              stroke="black"
              stroke-width="12.6878"
            />
            <path d="M0.545399 63.2682L2434.31 63.2684" stroke="black" stroke-width="14.6398" />
          </svg>
        </div>
      </Grid>
      <div class="paginator" v-bind:class="{ visible: paginatorVisible }">
        <a class="item" v-bind:class="{ active: column.index === 0 }" v-on:click="moveTo(0)">1</a>
        <a class="item" v-bind:class="{ active: column.index === 1 }" v-on:click="moveTo(1)">2</a>
      </div>
    </v-touch>
  </section>
</template>
<script>
import Grid from "./Grid.vue";
import ArrowAsLink from "./ArrowAsLink.vue";

export default {
  name: "Features",
  components: {
    Grid,
    ArrowAsLink
  },
  data: function() {
    return {
      intersectionOptions: {
        root: null,
        rootMargin: "0px 0px 0px 0px",
        threshold: 0.75
      },
      paginatorVisible: false,
      column: {
        translateX: 0,
        index: 0
      }
    };
  },
  methods: {
    moveTo(c) {
      this.column.index = c;
      this.column.translateX =
        Math.max(document.documentElement.clientWidth, window.innerWidth || 0) *
        -c;
    },

    showHidePaginator({ going, direction }) {
      if (going === this.$waypointMap.GOING_IN) {
        this.paginatorVisible = true;
      }
      if (going === this.$waypointMap.GOING_OUT) {
        this.paginatorVisible = false;
      }
    }
  }
};
</script>
<style scoped>
.features {
  display: block;
  position: relative;
  background-color: var(--RED);
  padding-bottom: 0;
}

.features-grid {
  flex-wrap: nowrap;
  align-items: center;
  flex-direction: row;
  align-content: center;
  justify-content: center;
}

.features,
.features-grid {
  min-height: 110vh;
}

@media only screen and (max-width: 576px) {
  .features {
    width: 100vw;
    overflow-x: hidden;
    min-height: calc(125 * var(--vh));
  }
  .features-grid {
    margin: 0;
    width: 200vw;
    overflow-x: hidden;
    transition: var(--TRANSITION);
    min-height: calc(125 * var(--vh));
  }
}
@media only screen and (min-width: 576px) and (max-width: 767px) {
  .features {
    width: 100vw;
    overflow-x: scroll;
    min-height: calc(110 * var(--vh));
  }
  .features-grid {
    margin: 0;
    width: 200vw;
    transition: var(--TRANSITION);
    min-height: calc(110 * var(--vh));
  }
}
@media only screen and (min-width: 768px) and (max-width: 992px) {
}
@media only screen and (min-width: 992px) {
}

.giantArrow {
  z-index: 100;
  position: absolute;
  top: 50vh;
  right: 0;

  height: 600px;
  margin-top: -300px;
  left: 0;
}

.giantArrow svg {
  position: absolute;
  top: calc(var(--LINE-HEIGHT) * 6);
  right: 0;
}

@media only screen and (max-width: 576px) {
  .giantArrow {
    z-index: 100;
    position: absolute;
    right: 0;
    left: 75px;
    overflow: hidden;
    top: calc(var(--vh) * 55);
  }
  .giantArrow svg {
    text-align: right;
    position: absolute;
    right: 0;
    top: calc(var(--LINE-HEIGHT) * 5);
  }
}
@media only screen and (min-width: 576px) and (max-width: 767px) {
  .giantArrow {
    z-index: 100;
    position: absolute;
    right: 0;
    left: 75px;
    overflow: hidden;
    top: calc(var(--vh) * 50);
  }
  .giantArrow svg {
    text-align: right;
    position: absolute;
    right: 0;
    top: calc(var(--LINE-HEIGHT) * 5);
  }
}
@media only screen and (min-width: 768px) and (max-width: 992px) {
  .giantArrow {
    z-index: 100;
    position: absolute;
    right: 0;
  }
  .giantArrow svg {
    text-align: right;
    position: absolute;
    right: 0;
    top: calc(var(--LINE-HEIGHT) * 5);
  }
}
@media only screen and (min-width: 992px) {
}

.feature-column {
  z-index: 400;
  margin-left: 20px;
  width: calc((var(--COLUMN-SIZE) * 4) - 20px);
  height: 600px;
}

@media only screen and (max-width: 576px) {
  .feature-column {
    width: calc(100vw - 25px);
    margin-left: 25px;
  }
}
@media only screen and (min-width: 576px) and (max-width: 767px) {
  .feature-column {
    width: calc(100vw - 75px);
    margin-left: 75px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 992px) {
  .feature-column {
    z-index: 400;
    margin-left: 0;
    width: calc((var(--COLUMN-SIZE) * 4));
  }
}
@media only screen and (min-width: 992px) {
}

/* .teaser {

}

.teaser:hover {
  transform: translateX(10px);
} */

.teaser-image {
  min-height: calc(var(--LINE-HEIGHT) * 16);
  margin-left: -10px;
}

.teaser-image img {
  height: calc(var(--LINE-HEIGHT) * 14);
}

@media only screen and (max-width: 576px) {
  .teaser-image {
    min-height: calc(var(--LINE-HEIGHT) * 13);
    margin-left: -10px;
  }
  .teaser-image img {
    height: calc(var(--LINE-HEIGHT) * 12);
  }

  .feature-column:nth-of-type(1) .teaser-image {
    margin-left: -10px;
  }
}
@media only screen and (min-width: 576px) and (max-width: 767px) {
  .teaser-image {
    min-height: calc(var(--LINE-HEIGHT) * 13);
    margin-left: -10px;
  }
  .teaser-image img {
    height: calc(var(--LINE-HEIGHT) * 12);
  }

  .feature-column:nth-of-type(1) .teaser-image {
    margin-left: -40px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 992px) {
  .teaser-image {
    min-height: calc(var(--LINE-HEIGHT) * 15);
    margin-left: -10px;
  }
  .teaser-image img {
    height: calc(var(--LINE-HEIGHT) * 12);
  }
}
@media only screen and (min-width: 992px) {
}

.teaser-link {
  font-size: 30px;
  display: inline-block;
  line-height: calc(var(--LINE-HEIGHT) * 2);
  color: inherit;
  text-decoration: none;
  position: relative;
  white-space: nowrap;
  padding-bottom: calc(var(--LINE-HEIGHT) * 1);
  transition: var(--TRANSITION);
}

.teaser span {
  text-decoration: underline;
  padding-right: 10px;
  color: inherit;
  transition: var(--TRANSITION);
}

.teaser-link:hover span {
  text-decoration-thickness: 3.5px;
}

.teaser-link strong {
  font-weight: bold;
  padding-right: 15px;
  text-decoration: none;
  color: inherit;
  position: absolute;
  left: -40px;
}

@media only screen and (max-width: 576px) {
  .teaser-link {
    font-size: 25px;
  }

  .teaser-link strong {
    position: relative;
    left: 0;
  }
}
@media only screen and (min-width: 576px) and (max-width: 767px) {
  .teaser-link {
    font-size: 25px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 992px) {
  .teaser-link {
    font-size: 25px;
  }
  .teaser-link strong {
    left: 0;
    top: calc(var(--LINE-HEIGHT) * -1.5);
  }
}
@media only screen and (min-width: 992px) {
}

.teaser-preview {
  line-height: 35px;
  letter-spacing: -0.3px;
  font-size: 25px;
}

@media only screen and (max-width: 576px) {
  .teaser-preview {
    margin-left: 35px;
    line-height: 35px;
    letter-spacing: -0.3px;
    font-size: 25px;
  }
}

.paginator {
  z-index: 10;
  height: calc(var(--LINE-HEIGHT) * 2);
  line-height: calc(var(--LINE-HEIGHT) * 2);
  position: fixed;
  left: 0;
  right: 0;
  width: 100vw;
  background-color: var(--RED);
  z-index: 1000;
  bottom: calc(var(--LINE-HEIGHT) * 4);
  transition: var(--TRANSITION);
  text-align: center;
  display: none;
}

@media only screen and (max-width: 576px) {
  .paginator {
    display: block;
    opacity: 0;
  }
  .paginator.visible {
    display: block;
    opacity: 1;
  }
}
@media only screen and (min-width: 576px) and (max-width: 767px) {
  .paginator {
    display: block;
    bottom: calc(var(--LINE-HEIGHT) * 4);
    opacity: 0;
  }
  .paginator.visible {
    display: block;
    opacity: 1;
  }
}

@media only screen and (min-width: 768px) and (max-width: 992px) {
  .paginator {
    display: none;
  }
}
@media only screen and (min-width: 992px) {
  .paginator {
    display: none;
  }
}

.paginator .item {
  width: 10px;
  height: 10px;
  border: 1.5px solid var(--BLACK);
  margin-left: 5px;
  margin-right: 5px;
  display: inline-block;
  border-radius: 11.5px;
  text-indent: -200px;
  overflow: hidden;
  cursor: pointer;
}

.paginator .item.active {
  background-color: var(--BLACK);
}
</style>



// WEBPACK FOOTER //
// src/components/Section.Features.vue